import HomeImage from './HomeImage';

export default HomeImage;
